import {IResponse, IScheduleRotation} from '@signal/asp-data-commons';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable, of} from 'rxjs';
import {Action, Store} from '@ngrx/store';
import * as fromActions from './schedule-rotation.actions';
import * as fromAdapter from './schedule-rotation.adapter';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators';
import {EmployeeService} from '../../shared/services/employee.service';
import {AlertService} from '../../shared/services/alert.service';
import {ScheduleRotationState} from './schedule-rotation.reducer';

@Injectable()
export class ScheduleRotationEffects {
  somethingWentWrongPleaseReloadThePage = 'otherTexts.somethingWentWrongPleaseReloadThePage';

  
  loadScheduleRotation: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadScheduleRotation>(
      fromActions.ScheduleRotationActionTypes.LOAD_SCHEDULE_ROTATION
    ),
    mergeMap((action: fromActions.LoadScheduleRotation) =>
      this.employeeService.getScheduleRotation(action.payload.department).pipe(
        map((scheduleRotation: IResponse<IScheduleRotation[]>) =>
          new fromActions.LoadScheduleRotationSuccess({
            department: action.payload.department,
            scheduleRotation: fromAdapter.convertArrayToObject(scheduleRotation.data)
          })),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.LoadScheduleRotationFailure({error: err, department: action.payload.department}));
        })
      )
    )
  ));

  
  addScheduleRotation: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.AddScheduleRotation>(
      fromActions.ScheduleRotationActionTypes.ADD_SCHEDULE_ROTATION
    ),
    mergeMap((action: fromActions.AddScheduleRotation) =>
      this.employeeService.createScheduleRotation(action.payload.department, action.payload.name, action.payload.payload).pipe(
        map((scheduleRotation: IResponse<IScheduleRotation>) => new fromActions.AddScheduleRotationSuccess({
          scheduleRotation: scheduleRotation.data,
          department: action.payload.department
        })),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.AddScheduleRotationFailure({error: err, department: action.payload.department}));
        })
      )
    )
  ));

  
  updateScheduleRotation: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.UpdateScheduleRotationName>(
      fromActions.ScheduleRotationActionTypes.UPDATE_SCHEDULE_ROTATION_NAME
    ),
    mergeMap((action: fromActions.UpdateScheduleRotationName) =>
      this.employeeService.updateScheduleRotation(action.payload.department, {id: action.payload.id, name: action.payload.name}).pipe(
        map((scheduleRotation: IResponse<IScheduleRotation>) => new fromActions.UpdateScheduleRotationNameSuccess({
          scheduleRotation: scheduleRotation.data,
          department: action.payload.department
        })),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.UpdateScheduleRotationNameFailure({error: err, department: action.payload.department}));
        })
      )
    )
  ));

  
  deleteScheduleRotation: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.DeleteScheduleRotation>(
      fromActions.ScheduleRotationActionTypes.DELETE_SCHEDULE_ROTATION
    ),
    mergeMap((action: fromActions.DeleteScheduleRotation) =>
      this.employeeService.deleteScheduleRotation(action.payload.department, action.payload.id).pipe(
        map((scheduleRotation: IResponse<IScheduleRotation>) => new fromActions.DeleteScheduleRotationSuccess({
          scheduleRotation: scheduleRotation.data,
          department: action.payload.department
        })),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.DeleteScheduleRotationFailure({error: err, department: action.payload.department}));
        })
      )
    )
  ));

  
  saveScheduleRotation: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.SaveScheduleRotation>(
      fromActions.ScheduleRotationActionTypes.SAVE_SCHEDULE_ROTATION
    ),
    switchMap((action: fromActions.SaveScheduleRotation) =>
      this.employeeService.updateScheduleRotation(action.payload.department, action.payload.scheduleRotation).pipe(
        map((scheduleRotation: IResponse<IScheduleRotation>) => {
          this.alertService.showAlert('otherTexts.scheduleRotationSavedSuccessfully', '', '', 5000, false);
          return new fromActions.SaveScheduleRotationSuccess({
            scheduleRotation: scheduleRotation.data,
            department: action.payload.department
          })
        }),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseReloadThePage);
          return of(new fromActions.SaveScheduleRotationFailure({error: err, department: action.payload.department}));
        })
      )
    )
  ));


  constructor(
    private actions$: Actions,
    private store$: Store<ScheduleRotationState>,
    private employeeService: EmployeeService,
    private alertService: AlertService
  ) {
  }
}
